import React from "react";
import Slider, { createSliderWithTooltip } from 'rc-slider';
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
// import './sliderStyle.css'
const SliderWithTooltip = createSliderWithTooltip(Slider);

const SliderComponent = ({ min = 0, max = 100, step = 1, initialValue = 50, colorClass = "blue", onChange = () => { },disabled=false }) => {

  return (
    <div className="w-full custom-slider">
      {/* Slider Track */}
      <SliderWithTooltip
        min={min}
        max={max}
        value={initialValue}
        disabled={disabled}
        marks={{ 25: 25, 50: 50, 75: 75 }}
        step={step}
        onChange={onChange}
        maximumTrackStyle={{ backgroundd: colorClass, height: '0.5rem'  }}
        trackStyle={{ background: colorClass, height: '0.5rem' }}
        tipFormatter={value => `${value}%`}
        dotStyle={{ backgroudnd: colorClass, borderColor: colorClass, height: '0.80rem', width: '0.80rem', bottom: '-5px' }}
        handleStyle={{ background: colorClass, borderColor: colorClass, height: '1.1rem', width: '1.1rem', marginTop: '-4px' }}
      />
    </div>
  );
};

export default SliderComponent;
